module.exports = __webpack_public_path__ + "img/04-dora&phil.2f847ba7.jpg";